import { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Chip,
  CircularProgress
} from "@mui/material";
import { motion } from "framer-motion";

import API from "../services/api";
import ParticleBackground from "../components/common/ParticleBackground";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await API.get("/orders/my-orders");
        setOrders(res.data);
      } catch (error) {
        console.log(error);
        alert("Error cargando órdenes");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "success";
      case "pending":
        return "warning";
      default:
        return "error";
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Container sx={{ py: 8, position: "relative", zIndex: 2 }}>
        {/* TITLE */}
        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            textAlign: "center",
            mb: 6,
            textShadow: "0 0 20px rgba(255,110,0,0.6)"
          }}
        >
          Mis Compras
        </Typography>

        {/* LOADING */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress color="warning" />
          </Box>
        ) : orders.length === 0 ? (
          <Typography sx={{ color: "#aaa", textAlign: "center" }}>
            No tenés compras todavía
          </Typography>
        ) : (
          <Grid container spacing={4}>
            {orders.map((order) => (
              <Grid item xs={12} md={6} key={order._id}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <Box
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      background: "rgba(20,20,20,0.8)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,110,0,0.3)",
                      boxShadow: "0 0 20px rgba(255,110,0,0.2)"
                    }}
                  >
                    {/* HEADER */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                      <Typography sx={{ color: "#fff", fontWeight: "bold" }}>
                        Orden #{order.paymentId}
                      </Typography>

                      <Chip
                        label={order.status}
                        color={getStatusColor(order.status)}
                        size="small"
                      />
                    </Box>

                    {/* ITEMS */}
                    <Box sx={{ mb: 2 }}>
                      {order.items.map((item, i) => (
                        <Typography key={i} sx={{ color: "#ccc" }}>
                          • {item.title} x{item.quantity}
                        </Typography>
                      ))}
                    </Box>

                    {/* TOTAL */}
                    <Typography
                      sx={{
                        color: "#ffae00",
                        fontWeight: "bold",
                        fontSize: "1.2rem"
                      }}
                    >
                      Total: ${order.total}
                    </Typography>

                    {/* FECHA */}
                    <Typography sx={{ color: "#777", fontSize: "0.8rem", mt: 1 }}>
                      {new Date(order.createdAt).toLocaleString()}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default MyOrders;